import { IOrderActivityLog } from "../../../../interfaces";
import UpdatedPositionImageLog from "./UpdatedLog";
import UpdatedStatusLog from "./UpdatedStatusLog";

/**
 * This component is operation update action component for activity log
 * @param param0 activity log details
 */
const UpdatedLogComponent = ({
  activityLog,
}: {
  activityLog: IOrderActivityLog;
}) => {
  switch (activityLog.field) {
    case "status":
      return (
        <UpdatedStatusLog
          createdAt={activityLog.createdAt}
          value={activityLog.value}
        />
      );
    case "positionImage":
      return activityLog.positionImage ? (
        <UpdatedPositionImageLog
          positionImage={activityLog.positionImage}
          updatedBy={activityLog.updatedBy}
          createdAt={activityLog.createdAt}
        />
      ) : (
        <></>
      );
    default:
      return <></>;
  }
};

export default UpdatedLogComponent;
